import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { SUSY_AUTH_USER_PROJECT_PATH } from '../constants/route-paths';

interface IProps {
    children: ReactNode;
}

export const NestedPathKeeper = ({ children }: IProps) => {
    const location = useLocation();

    if (location.pathname.includes('projectDetails')) {
        localStorage.setItem(SUSY_AUTH_USER_PROJECT_PATH, location.pathname);
    }

    return <> {children} </>;
};
